import React from "react";
import DatePicker from "react-datepicker";
import "../../styles/advertisement.css";
import "../../styles/qualification.css";
import { getYearList } from "../actions/profileAction";
import qualificationinformation from "../labels/qualification_information_en.json";
import qualificationinformation_hindi from "../labels/qualification_information_hin.json";
import numberformat from "../labels/serial_nos_en.json";
import QualificationTypeDropdown from "./QualificationTypeDropdown";

const DisabledQualificationForm = () => {
  return (
    <form className="qualifcation_form" autoComplete="off">
      <div className="row">
        <QualificationTypeDropdown />
        <div className="col-md-4 mb-3 mt-3 responsive-input-stand-name">
          <label className="float-start mb-0">
            {numberformat["4.2"]}&nbsp;{qualificationinformation.NAME_OF_DEGREE}
            {qualificationinformation_hindi.NAME_OF_DEGREE_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <select
            className="form-select bg-color"
            name="qualificationnamecode"
            disabled
          >

          </select>
        </div>
        <div className="  col-md-4 mb-3 mt-3 responsive-input-stand-subject">
          <label className="float-start mb-0">
            {numberformat["4.3"]}&nbsp;{qualificationinformation.SUBJECT}
            {qualificationinformation_hindi.SUBJECT_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <select
            className="form-select bg-color"
            name="subjectLookupId"
            disabled
          >
          </select>
        </div>
        {/** Following div is to displayed conditionally */}
        <div className="  col-md-4 mb-3  responsive-input-stand-state">
          <label className="float-start mb-0 ">
            {numberformat["4.4"]}&nbsp;{qualificationinformation.STATE}
            {qualificationinformation_hindi.STATE_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <select className="form-select bg-color" name="statecode" disabled>
            {" "}
          </select>
        </div>
        <div className="form-group  col-md-4 responsive-input-stand-university">
          <label className="float-start" htmlFor="universitycode">
            {numberformat["4.5"]}&nbsp;
            {qualificationinformation.BOARD_UNIVERSITY}
            {qualificationinformation_hindi.BOARD_UNIVERSITY_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <select
            id="universitycode"
            className="form-control bg-color"
            name="universitycode"
            disabled
          >
            {" "}
          </select>
        </div>
        <div className="col-md-4 responsive-input-stand-result">
          <label className="float-start mb-0">
            {numberformat["4.6"]}&nbsp;{qualificationinformation.RESULT}{" "}
            {qualificationinformation_hindi.RESULT_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <select className="form-select bg-color" name="typeResult" disabled />
        </div>
        <div className="  col-md-4 mb-3 mt-3 responsive-input-stand-result-date">
          <label className="float-start mb-0">
            {numberformat["4.7"]}&nbsp;{qualificationinformation.RESULT_DATE}{" "}
            {qualificationinformation_hindi.RESULT_DATE_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <DatePicker
            showIcon
            defaultValue={new Date()}
            className="form-control bg-color"
            disabled
            icon={
              <img
                src="/icons/calender.png"
                className="date-picker-icon"
                alt="date-icon"
              ></img>
            }
          />
        </div>
        <div className=" col-md-4 mt-3 mb-3 responsive-input-stand-attempts">
          <label className="float-start mb-0">
            {numberformat["4.8"]}&nbsp;{qualificationinformation.ATTEMPTS}{" "}
            {qualificationinformation_hindi.ATTEMPTS_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            name="attempts"
            disabled
          />
        </div>
        {/* --------------------------------------------------------------------------------------------- */}
        <div className="col-md-4 mb-3 mt-3 responsive-input-stand-obtain-Marks">
          <label className="float-start mb-0">
            {numberformat["4.9"]}&nbsp;
            {qualificationinformation.OBTAINED_MARKS}
            {/* {isResultDateMandatory ? (
              <span className="redColor">*</span>
            ) : (
              ""
            )}{" "} */}
            <span> {qualificationinformation_hindi.OBTAINED_MARKS_HIN} </span>
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            maxLength={5}
            disabled
          />
        </div>
        <div className="col-md-4 mb-3 mt-3 responsive-input-stand-total-Marks">
          <label className="float-start mb-0">
            {numberformat["4.10"]}&nbsp;
            {qualificationinformation.TOTAL_MARKS}
            {/* {isResultDateMandatory ? (
              <span className="redColor">*</span>
            ) : (
              ""
            )}{" "} */}
            <span> {qualificationinformation_hindi.TOTAL_MARKS_HIN} </span>
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            maxLength={5}
            // value={
            //   qualificationState.totalMarks
            //     ? qualificationState.totalMarks
            //     : ""
            // }
            disabled
          />
        </div>
        {/* -------------------------------------------------------------------------------------------------------------- */}
        <div className="  col-md-4 mb-3 responsive-input-stand-CGPA">
          <label className="float-start mb-0">
            {numberformat["4.11"]}&nbsp;
            {qualificationinformation.PERCENTAGE_GRADE}
            {qualificationinformation_hindi.PERCENTAGE_GRADE_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            name="percentageGrade"
            disabled
          />
        </div>
        {/* <div className="  col-md-4  mb-3 responsive-input-stand-duration">
          <label className="float-start mb-0">
            {numberformat["4.10"]}&nbsp;
            {qualificationinformation.COURSE_DURATION}
            <span className="redColor">*</span>{" "}
            {qualificationinformation_hindi.COURSE_DURATION_hin}{" "}
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            name="courseDurationMonths"
            disabled

          />
        </div> */}
        <div className="col-md-4 mb-3 mt-3 responsive-input-stand-duration">
          <label className="float-start mb-0">
            {numberformat["4.12"]}&nbsp;
            {qualificationinformation.COURSE_DURATION}
          </label>
          <span> {qualificationinformation_hindi.COURSE_DURATION_hin} </span>
          <span className="redColor">*</span>
          <select
            className="form-select bg-color"
            name="courseDurationMonths"
            disabled
          >
          </select>
        </div>
        <div className="  col-md-4  mb-3 responsive-input-stand-class-grade ">
          <label className="float-start mb-0">
            {numberformat["4.13"]}&nbsp;{qualificationinformation.CLASS_GRADE}{" "}
            {qualificationinformation_hindi.CLASS_GRADE_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <select
            className="form-select bg-color"
            name="classGradeLookupId"
            disabled
          />
        </div>
        <div className="  col-md-4  mb-3 responsive-input-stand-mode">
          <label className="float-start mb-0">
            {numberformat["4.14"]}&nbsp;{qualificationinformation.MODE}{" "}
            {qualificationinformation_hindi.MODE_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <select
            className="form-select bg-color"
            name="modeLookupId"
            disabled
          />
        </div>
        <div className="  col-md-4  mb-3 responsive-input-stand-comp-subj">
          <label className="float-start mb-0">
            {numberformat["4.15"]}&nbsp;
            {qualificationinformation.COMPULSORY_SUBJECTS}
            {qualificationinformation_hindi.COMPULSORY_SUBJECTS_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <select
            type="text"
            className="form-control bg-color"
            name="compulsorySubjects"
            disabled
          ></select>
        </div>

        {/* Adding two new input boxes */}

        <div className="  col-md-4  mb-3 responsive-input-stand-opt-subj ">
          <label className="float-start mb-0">
            {numberformat["4.16"]}&nbsp;
            {qualificationinformation.OPTIONAL_SUBJECTS}
            {qualificationinformation_hindi.OPTIONAL_SUBJECTS_hin}{" "}
            <span className="redColor">*</span>{" "}
          </label>
          <select
            type="text"
            className="form-control bg-color"
            name="optionalSubjects"
            disabled
          ></select>
        </div>

        <div className="col-md-4 mb-3 responsive-input-stand-seat">
          <label className="float-start mb-0">
            {numberformat["4.17"]}&nbsp;
            {qualificationinformation.SEAT_NUMBER}
            {qualificationinformation_hindi.SEAT_NUMBER_hin}{" "}
            <span className="redColor">*</span>{" "}
            {""}
          </label>
          <input
            type="text"
            className="form-control bg-color text-uppercase"
            name="seatNumber"
            disabled
          />
        </div>

        <div className="col-md-4 mb-3 responsive-input-stand-year-pass">
          <label className="float-start mb-0">
            {numberformat["4.18"]}&nbsp;
            {qualificationinformation.YEAR_OF_PASSING}
            {qualificationinformation_hindi.YEAR_OF_PASSING_hin}{" "}
            <span className="redColor">*</span>{" "}{" "}
          </label>
          <select
            className="form-select  bg-color"
            name="yearOfPassing"
            maxLength={4}
            id="sq"
            disabled
          >
            <option key={0} value="">
              {"Select Year"}
            </option>
            {getYearList()}
          </select>
        </div>
      </div>
    </form>
  );
};
export default DisabledQualificationForm;
